import { render, staticRenderFns } from "./OrdersInboundFilter.vue?vue&type=template&id=3c8a1498&scoped=true"
import script from "./OrdersInboundFilter.vue?vue&type=script&lang=js"
export * from "./OrdersInboundFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8a1498",
  null
  
)

export default component.exports